// extracted by mini-css-extract-plugin
export var divider = "_md-0";
export var systemMessage = "_md-1";